import React, { useMemo } from 'react'
import CruiseDescription from './CruiseDescription'

interface Props {
  offer: App.Offer | App.OfferSummary
  className?: string;
}

function CruiseFlashDescription({ offer }: Props): JSX.Element {
  const duration = useMemo(() => {
    if (offer.tileDurationLabel && offer.lowestPricePackage) {
      const isNight = offer.tileDurationLabel
        .toLowerCase().includes('night') ? 0 : 1

      return offer.lowestPricePackage.duration - isNight
    }

    return 1
  }, [offer.lowestPricePackage, offer.tileDurationLabel])

  return <CruiseDescription
    duration={duration}
    portLength={offer.locations.length}
    shipName={offer.vendorVehicle ?? ''}
    cruiseLineName={offer.vendorName ?? ''}
  />
}

export default CruiseFlashDescription
